/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkTypeResponseDto
 */
export interface WorkTypeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof WorkTypeResponseDto
     */
    id: string;
    /**
     * Stable code; UI labels come from i18n (`workType.{code}`)
     * @type {string}
     * @memberof WorkTypeResponseDto
     */
    code: string;
    /**
     * 
     * @type {Date}
     * @memberof WorkTypeResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof WorkTypeResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the WorkTypeResponseDto interface.
 */
export function instanceOfWorkTypeResponseDto(value: object): value is WorkTypeResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function WorkTypeResponseDtoFromJSON(json: any): WorkTypeResponseDto {
    return WorkTypeResponseDtoFromJSONTyped(json, false);
}

export function WorkTypeResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkTypeResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function WorkTypeResponseDtoToJSON(json: any): WorkTypeResponseDto {
    return WorkTypeResponseDtoToJSONTyped(json, false);
}

export function WorkTypeResponseDtoToJSONTyped(value?: WorkTypeResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

